var regularSearchParamsCallbacks = {};

/**
* Zoekparameters voor producten
*
* @type Object
* @return Object
* @todo variabelen goed ophalen uit DOM
*/
regularSearchParamsCallbacks.product = function() {
    var params = {};

    /** @var string[] Zoektermen */
    /** Zoekresultaten voor: '' & input waarde van 'Zoek binnen resultaten' */
    var originalSearch = '';
    if($('[data-hook="search-input"]').length > 0) {
        originalSearch = $('[data-hook="search-input"]').html();
    }
    var sidebarSearch = $('[data-hook="search-refine"]').val();

    params.queries = [originalSearch];
    if (sidebarSearch)
        params.queries.push(sidebarSearch);

    /** @var string Model van product */
    params.model = [];
    $('[name="Product[model]"]').each(function() {
        if (!$(this).is(':checked'))
            return;
        params.model.push($(this).val());
    });

    /** @var int Staat van boek */
    params.state = [];//$('[name="Product[state]"]').val();
    $('[name="Product[state]"]').each(function() {
        if (!$(this).is(':checked'))
            return;
        params.state.push($(this).val());
    });

    /** @var string Taal van boek */
    //taal search
    params.language = [];
    $('[name="Product[language]"]').each(function() {
        var value = $(this).val();

        // overslaan wanneer tab niet active is of Alles is geselecteerd. Alles is geen waarde die wordt herkend als language option
        if (!$(this).hasClass('active-sorting-tab') || value.toLowerCase() == 'alles') { return; }

        params.language.push($(this).val());
    });

    /** @var string[] Lijst van actiecategorieën */
    params.actionCategories = [];
    $('[name="ActionCategory"]').each(function() {
        if (!$(this).is(':checked'))
            return;
        params.actionCategories.push($(this).val());
    });

    /** @var string[] Lijst van subcategorieën */
    params.subCategories = [];
    $('[name="subCategories"]').each(function() {
        if (!$(this).is(':checked')) {
            return;
        }
        //Wanneer geen van de subcategorie checkboxes gecheckt zijn, deze allemaal mee sturen
        if($(this).closest('.subcategory-label').hasClass('subcategory-label')) {
            var categoryId = $(this).val();
            //var subSubCategories = $('[data-parent="'+categoryId+'"] [name="subCategories"]');
            var checked = $('[data-parent="'+categoryId+'"] [name="subCategories"]:checked');
            if(checked.length == 0) {
                $('[data-parent="'+categoryId+'"] [name="subCategories"]').each(function() {
                    params.subCategories.push($(this).val());
                });
            }
        }
        params.subCategories.push($(this).val());
    });
    //Wanneer geen enkele sub categorie geselecteerd is, allemaal tonen
    if(params.subCategories.length < 1) {
        $('[name="subCategories"]').each(function() {
            params.subCategories.push($(this).val());
        });
        // ook meesturen id van hoofdcategorie
        var topLevelCategoryId = $('[data-hook="product-container"]').data('categoryId');
        if (typeof topLevelCategoryId !== 'undefined') {
            params.subCategories.push(topLevelCategoryId);
        }
    }

    /** @var int[] Bedragen van en tot */
    var priceRange = $('#ex2').val();
    // @todo default values laten vullen op basis van slider zodat deze variabelen maar op 1 plek bijgehouden hoeven te worden
    priceRange = priceRange.split(',');

    params.price = [priceRange[0], priceRange[1]];

    //Bepalen of data table product is, of dat het om niew binnen pagina gaat, of dat het een zoekresultaat is
    var dataTable = $('[data-table="product"]');
    if($('[data-table="newInStock"]').length > 0) {
        dataTable = $('[data-table="newInStock"]')
    } else if($('[data-table="searchResults"]').length > 0) {
        dataTable = $('[data-table="searchResults"]')
    }
    /** @var relevance|priceAsc|priceDesc */
    params.sort = dataTable.find('[data-hook="sort"]').val();

    /** @var int */
    params.numResultsPerPage = dataTable.find('[data-hook="numResultsPerPage"]').val();

    /** @var int */
    var page = dataTable.find('[data-hook="pagination"] .active').attr('data-page');
    if(!page) { page = 1; }
    params.page = parseInt(page);

    //URL aanpassen met key van huidige filter settings
    if(!firstLoad) {
        var searchIdentifier = makeid();
        var urlPath = window.location.href;
        var substring = "#filter:";
        if(urlPath.indexOf(substring) !== -1) {
            urlPath = urlPath.split(substring);
            //urlPath = urlPath[0];
            searchIdentifier = urlPath[urlPath.length-1];
        } else {
            urlPath = urlPath+substring+searchIdentifier;
            window.history.pushState({"html":document.getElementsByTagName("html").innerHTML,"pageTitle":document.title},"", urlPath);
        }
        //Params opslaan in localstorage
        var searchParams = {
            "key": searchIdentifier,
            "params": JSON.stringify(params)
        }
        console.log(searchParams);

        //Item voor searchparams opslaan, en voor categorieën
        var localStorageVariable = $('[data-localstorage]').attr('data-localstorage');
        localStorage.setItem(localStorageVariable+'Params', JSON.stringify(searchParams));
    }
    return params;
}

regularSearchParamsCallbacks.author = function() {
    var params = {};
    params.query = $('.refine-search').val();

    /** @var relevance|priceAsc|priceDesc */
    params.sort = $('[data-table="author"] [data-hook="sort"]').val();

    /** @var int */
    params.numResultsPerPage = $('[data-table="author"] [data-hook="numResultsPerPage"]').val();

    var page = $('[data-table="author"] [data-hook="pagination"] .active').attr('data-page');
    if(!page) {
        page = 1;
    }
    params.page = parseInt(page);

    return params;
}

regularSearchParamsCallbacks.category = function() {
    var params = {};
    params.query = $('.refine-search').val();

    /** @var relevance|priceAsc|priceDesc */
    params.sort = $('[data-table="category"] [data-hook="sort"]').val();

    /** @var int */
    params.numResultsPerPage = $('[data-table="category"] [data-hook="numResultsPerPage"]').val();

    var page = $('[data-table="category"] [data-hook="pagination"] .active').attr('data-page');
    if(!page) {
        page = 1;
    }
    params.page = parseInt(page);

    return params;
}

regularSearchParamsCallbacks.publisher = function() {
    var params = {};
    params.query = $('.refine-search').val();

    /** @var relevance|priceAsc|priceDesc */
    params.sort = $('[data-table="publisher"] [data-hook="sort"]').val();

    /** @var int */
    params.numResultsPerPage = $('[data-table="publisher"] [data-hook="numResultsPerPage"]').val();

    var page = $('[data-table="publisher"] [data-hook="pagination"] .active').attr('data-page');
    if(!page) {
        page = 1;
    }
    params.page = parseInt(page);

    return params;
}
